import { ViewModel, View } from "binder"
import { DistrictSelector } from "src/erp/enterpriseAdministration/districts/districtManipulation/districtSelector";
import { ServerConnection } from "src/server/serverConnection";
import { IGateway, IPaymentInfoProvider } from "../IGateway";
import { CashGatewayView } from "./cashGateway-view"
import { translate } from "src/common/utilities";

export class CashGatewayViewModel extends ViewModel implements IGateway {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    get title(): string {
        return translate("cashGateway-viewModel.cash", {});
    }

    GetDefaultView(): View<ViewModel> {
        return new CashGatewayView();
    }

    public getTypeId(): string {
        return "VM-FCCDAC4D-B521-4C43-9A8C-8CE8B14EC036"
    }

    public set district(v: DistrictSelector) { this._district = v; } public get district(): DistrictSelector { return this._district; } private _district: DistrictSelector;

    initialLoad(): void {
        this.district = new DistrictSelector(this);
    }

    async save(dataProvider: IPaymentInfoProvider): Promise<any> {
        let paymentInfo = dataProvider.getBasePaymentInfoDto();
        return await ServerConnection.callServer('Complex/PaymentProcessServices/CreateCashPayment', {
            ProcessId: paymentInfo.processId,
            Attachments: paymentInfo.attachments.map(p => {
                return {
                    Data: p.content,
                    Name: p.name
                }
            }),
            DistrictId: this.district.selectedItem.id
        });
    }

    validate(): string[] {
        if (this.district.selectedItem == null) {
            return [translate("cashGateway-viewModel.cashBox", {})]
        }
        return [];
    }
}
